import { AppRoutes } from 'common/types';
import type { NavItems } from 'common/common_components/MenuWithBurger/types';

export const navItems: NavItems = [
  {
    translationKey: 'MENU_SIDEBAR_WELCOME_NAV_ITEM',
    link: AppRoutes.HOME,
  },
  {
    translationKey: 'MENU_SIDEBAR_BOLIDES_NAV_ITEM',
    link: AppRoutes.RESERVATION,
  },
  {
    translationKey: 'MENU_SIDEBAR_SEARCH_NAV_ITEM',
    link: AppRoutes.SEARCH,
  },
  {
    translationKey: 'MENU_SIDEBAR_ENGAGEMENTS_NAV_ITEM',
    link: AppRoutes.ECOLOGY,
  },
  {
    translationKey: 'MENU_SIDEBAR_SUBSCRIPTIONS_NAV_ITEM',
    link: AppRoutes.SUBSCRIBE,
  },
  {
    translationKey: 'ABOUT_US',
    link: AppRoutes.ABOUT_US,
  },
];
